import { useState, useEffect, forwardRef, ReactElement, Ref } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import appstore_logo from '../../assets/logo/appstore_logo.png';
import playstore_logo from '../../assets/logo/playstore_logo.png';

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function AlertDialogSlide({ ...props }) {
  const [open, setOpen] = useState(false);
  const AppURL = props.isAndroid
    ? 'https://play.google.com/store/apps/details?id=io.frigovide&hl=fr'
    : 'https://apps.apple.com/fr/app/frigo-vide/id1671820582';

  useEffect(() => {
    setOpen(props.openIsMobile);
  }, [props.openIsMobile]);

  return (
    <div>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#f5f5f5',
            maxWidth: '760px',
          },
        }}
        onClose={() => {
          props.disallow();
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby='alert-dialog-slide-description'>
        <DialogTitle>{'Application mobile'}</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '@media (max-width: 550px)': {
              flexDirection: 'column',
            },
          }}>
          <DialogContentText
            sx={{
              fontSize: '1.2rem',
            }}
            id='alert-dialog-slide-description'>
            Pour une meilleure expérience, nous vous conseillons d'utiliser
            notre application mobile.
            <br />
            <br />
          </DialogContentText>
          <a
            href={AppURL}
            target='_blank'
            rel='noreferrer'
            style={{
              textDecoration: 'none',
            }}>
            <img
              src={props.isAndroid ? playstore_logo : appstore_logo}
              alt='cookies logo'
              style={{
                width: '100%',
                height: 'auto',
              }}
            />
          </a>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
